export * from './interface';

export { addDepartment } from './addDepartment';
export type { IAddInput, IAddOutput } from './addDepartment';

export { changeMemberDepartment } from './changeMemberDepartment';
export type { IChangeDepartmentInput, IChangeDepartmentOutput } from './changeMemberDepartment';

export { deleteDepartment } from './deleteDepartment';
export type { IDeleteDepartmentInput, IDeleteDepartmentOutput } from './deleteDepartment';

export { getDepartmentListByLevel } from './departmentByLevel';
export type { IDepartByLevel } from './departmentByLevel';

export { getDepartmentListByManagerId } from './departmentByManagerId';

export { getDepartmentList } from './departmentList';

export { editDepartment } from './editDepartment';
export type { IEditInput, IEditOutput } from './editDepartment';

export { getDepartmentsByUmuid, DEPATMENT_ROLE } from './getDepartmentsByUmuid';
export type { IDepartmentsByUmuid, IGetDepartmentsByUmuid } from './getDepartmentsByUmuid';

export { sortDepartment } from './sortDepartment';
export type { ISortDepartmentOutput, ISortDepartmentParam } from './sortDepartment';

export { getSubDepartmentList, getManageDepartmentList, getManagersById } from './subDepartmentList';
export type { ISubDepartListInfo, IManageDepartmentListParam, IManageDepartmentInfo } from './subDepartmentList';

export { getSugDepartment } from './sugDepartment';
export type { ISugDepartListInfo, ISugDepartListParam } from './sugDepartment';
